"use client";
import f from "styled-components";
import r from "react";
import d from "./index.es156.js";
import h from "./index.es157.js";
const M = (t, o, n) => (e) => t - o > n - t ? e < t ? 50 - 50 * (t - e) / (t - o) : 50 + 50 * (e - t) / (t - o) : e > t ? 50 + 50 * (e - t) / (n - t) : 50 - 50 * (t - e) / (n - t), S = ({ min: t, max: o, midValue: n, markValue: e }) => {
  if (n < t || n > o)
    return null;
  const p = Math.min(t, o, e || t), c = Math.max(t, o, e || o), s = M(
    n,
    p,
    c
  ), i = typeof e == "number" ? { mark: s(e) } : {};
  return {
    left: s(t),
    right: 100 - s(o),
    ...i
  };
}, g = f.div`
  position: absolute;
  height: 100%;
  width: 50%;
  left: 2px;
  border-right: 4px solid #000;
`, m = f.div`
  min-height: 75px;
  min-width: 10vw;
  position: relative;
  & svg: {
    border: 2px solid #9d77f0;
  }
`, $ = ({
  max: t,
  min: o,
  midValue: n,
  markValue: e,
  id: p,
  scopeName: c,
  regionName: s
}) => {
  const i = S({
    min: Math.min(o, t),
    max: Math.max(o, t),
    midValue: n,
    markValue: e
  }), l = {
    position: "absolute",
    height: 15,
    top: 30,
    left: `${i?.left || 0}%`,
    right: `${i?.right || 0}%`
  }, b = `Spredning for ${c}, min: ${Number(
    o.toFixed(1)
  ).toLocaleString("nb-NO")}, gjennomsnitt: ${Number(
    n.toFixed(1)
  ).toLocaleString("nb-NO")}, maks: ${Number(t.toFixed(1)).toLocaleString(
    "nb-NO"
  )}`;
  return /* @__PURE__ */ r.createElement(m, null, /* @__PURE__ */ r.createElement("div", { title: b, style: l }, /* @__PURE__ */ r.createElement(h, { id: p, style: { border: "solid 2px #9d77f0" } })), /* @__PURE__ */ r.createElement(g, null), typeof e == "number" && /* @__PURE__ */ r.createElement(
    "div",
    {
      style: {
        position: "absolute",
        top: 30,
        left: `calc(${i?.mark || 0}% - 8px)`
      }
    },
    /* @__PURE__ */ r.createElement(d, null)
  ));
};
export {
  $ as default
};
//# sourceMappingURL=index.es158.js.map
